let pendingRequests: { [key: string]: boolean | undefined } = {};

const requestCache = {
  isPending: (key: string, value?: boolean) => {
    if (typeof value === 'undefined') {
      return !!pendingRequests[key];
    }

    pendingRequests[key] = value;
    return value;
  },
  reset: () => (pendingRequests = {}),
};

export default requestCache;
